import request from "@/router/axios";

export const getList = (current, size, params) => {
  return request({
    url: "/api/jida-system/dict-biz/list",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getParentList = (current, size, params) => {
  return request({
    url: "/api/jida-system/dict-biz/parent-list",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getChildList = (current, size, parentId, params) => {
  return request({
    url: "/api/jida-system/dict-biz/child-list",
    method: "get",
    params: {
      ...params,
      current,
      size,
      parentId: parentId,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: "/api/jida-system/dict-biz/remove",
    method: "post",
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: "/api/jida-system/dict-biz/submit",
    method: "post",
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: "/api/jida-system/dict-biz/submit",
    method: "post",
    data: row,
  });
};

export const getDict = (id) => {
  return request({
    url: "/api/jida-system/dict-biz/detail",
    method: "get",
    params: {
      id,
    },
  });
};
export const getDictTree = () => {
  return request({
    url: "/api/jida-system/dict-biz/tree?code=DICT",
    method: "get",
  });
};

export const getDictionary = (params) => {
  return request({
    url: "/api/jida-system/dict-biz/dictionary",
    method: "get",
    params,
  });
};
export const getUrlAsyn = (params) => {
  return request({
    url: `/api/jida-system/dict-biz/dictionary?code=${params}`,
    method: "get",
  });
};
export const getUrl = (code) => {
  return `/api/jida-system/dict-biz/dictionary?code=${code}`;
};

// 获取层级字典
export const getDictionaryTree = (params) => {
  return request({
    url: "/api/jida-system/dict-biz/dictionary-tree",
    method: "get",
    params,
  });
};
export const getDictionaryDetail = (params) => {
  return request({
    url: "/api/jida-system/dict/dictionary",
    method: "get",
    params,
  });
};

export const getParamDict = (params) => {
  return request({
    url: "/api/jida-system/param/detail",
    method: "get",
    params,
  });
};
